var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium",
    focusable: "false",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.9999V12.9999H22V10.9999H17ZM16.97 19.9599C18.03 20.5099 19.41 21.2399 20.51 21.8099C20.82 21.2199 21.13 20.6299 21.44 20.0399C20.35 19.4699 18.96 18.7299 17.9 18.1799C17.59 18.7799 17.28 19.3699 16.97 19.9599ZM21.44 3.96994C21.13 3.37994 20.83 2.77994 20.52 2.18994C19.42 2.75994 18.03 3.47994 16.97 4.02994C17.28 4.61994 17.58 5.21994 17.89 5.80994C18.96 5.25994 20.34 4.54994 21.44 3.96994ZM4 7.99994C2.9 7.99994 2 8.89994 2 9.99994V13.9999C2 15.0999 2.9 15.9999 4 15.9999H5V19.9999H7V15.9999H9L15 18.9999V4.99994L9 7.99994H4ZM10.03 9.70994L13 8.52994V15.4699L9.55 13.9999H4V9.99994H9.55L10.03 9.70994Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCampaign);
export default __webpack_public_path__ + "static/media/icon-campaign.da7b366707fd7fb2d16bc357150d6ecc.svg";
export { ForwardRef as ReactComponent };